export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-twitter-22b6a5f3c196a4bf13adca9327711c6f.svg";